<template lang="html">
  <div>

    <v-container>
      <h1 class="mb-3">{{content.niceName}}</h1>

      <!-- RICH EDITOR -->
      <template v-if="useRichEditor">
        <h2>PT</h2>
        <vue-editor class="mb-4" v-model="content.pt" />
        <h2>EN</h2>
        <vue-editor class="mb-4" v-model="content.en" />
        <h2>ES</h2>
        <vue-editor class="mb-4" v-model="content.es" />
      </template>

      <!-- POOR EDITOR -->
      <template v-else>
        <v-textarea
        outline
        label="PT"
        v-model="content.pt"
        ></v-textarea>

        <v-textarea
        outline
        label="EN"
        v-model="content.en"
        ></v-textarea>

        <v-textarea
        outline
        label="ES"
        v-model="content.es"
        ></v-textarea>
      </template>

    </v-container>

    <v-container>
      <v-layout justify-space-between>

        <div>
        </div>

        <div>
          <v-btn color="" large @click="clickCancel()">Cancelar</v-btn>
          <v-btn color="success" large @click="clickSave()">Guardar</v-btn>
        </div>
      </v-layout>
    </v-container>

  </div>
</template>

<script>
import {mapActions} from 'vuex'
export default {
  created: function () {
    this.content = this.$route.params.content
  },
  data: function () {
    return {
      content: null
    }
  },
  computed: {
    useRichEditor: function () {
      return this.content.richText == 1
    }
  },
  methods: {
    ...mapActions([
      'updateContent'
    ]),
    clickCancel: function () {
      this.$router.push({ name: 'ContentList' })
    },
    clickSave: function () {
      this.updateContent(this.content).then(() => {
        this.$router.push({ name: 'ContentList' })
      })
    },
  }
}
</script>

<style lang="css" scoped>
</style>
